import { useEffect, useRef, useState } from "react"
import { useNavigate, useParams } from "react-router-dom";
import styled from 'styled-components';
import PatronPermissionForm from '../../views/BackStage/PatronPermissionForm'
import { usePermission } from '../../controllers/PermissionController';
import { Row, Col } from '../../../ui/ot'
import { Toaster, toast } from 'sonner'
import { Button } from "../../../ui/ot"

const EditPatronPermission = () => {
    const thisJS = "EditPatronPermission"
    const { borrowernumber } = useParams()
    const formRef = useRef()
    const navigate = useNavigate()
    const [modalLoading, setModalLoading] = useState(false)
    const [axiosMode, setAxiosMode] = useState("patch")
    const onFormFinish = (values) => {
        console.log(thisJS, "onFormFinish", axiosMode, values)
        //let newValue = { ...values }
        //let messageData = values?.message || []
        if (axiosMode === "get") { return; }
        patchPermissionData([values])
    }

    const {
        PermissionData,
        getPermissionData,
        postPermissionData,
        patchPermissionData,
        deletePermissionData,
    } = usePermission({
        onBefore: ({ axiosMode, values }) => {
            console.log(thisJS, "PermissionData", axiosMode, "onBefore", values)
            const bIsGet = axiosMode === "get"
            if (!bIsGet) { setModalLoading(true) }
        },
        onFinish: ({ axiosMode, status, values }) => {
            console.log(thisJS, "PermissionData", axiosMode, "onFinish", status, values)
            const bIsPatch = axiosMode === "patch"
            if (bIsPatch) {
                const cMode = "修改"
                if (status === "success") {
                    toast.success(cMode + "成功");
                    getPermissionData({
                        borrowernumber, size: 30
                    })
                        .then((response) => {
                            let datas = response?.data
                        })
                } else {
                    toast.error(cMode + "失敗");
                }
                setModalLoading(false)
            }
        }
    })

    useEffect(() => {
        getPermissionData({
            borrowernumber: borrowernumber, size: 30
        })
            .then((response) => {
                console.log(thisJS, "PermissionData", axiosMode, "useEffect", response)
                const userflags = (response?.data || []).map((oRow) => ({
                    ...oRow, expanded: oRow.permissions.length > 0 ? 1 : 0
                }));
                //const newPermissions = PermissionData.map((item) => ({
                //    bit: item.bit,
                //    allow_flag: item.allow_flag,
                //    mainTitle: item.flagdesc,
                //    subTitle: `(${item.flag})`,
                //    permissions: item.permissions // 這裡可以加入更多的子權限 
                //}));
                formRef.current.setValues({ borrowernumber, userflags })
            })
    }, [])

    return (
        <Row>
            <Toaster richColors position="top-center" />
            <Col span={24}>
                <Title>修改讀者權限</Title>
            </Col>
            <Col span={24}>
                <Row justify="end">
                    <Col>
                        <ButtonGroup>
                            <Button
                                onClick={() => {
                                    formRef.current.onFormSubmit()
                                }} >
                                儲存
                            </Button>
                            <Button
                                variant="ghost"
                                onClick={() => {
                                    navigate('/library/backstage/Patrons')
                                }}
                            >
                                取消</Button>
                        </ButtonGroup>
                    </Col>
                </Row>
            </Col>
            <Col span={24}>
                <PatronPermissionForm
                    ref={formRef}
                    onFormFinish={onFormFinish}
                />
            </Col>
        </Row>
    );
}
const Title = styled.div`
text-align: left;
width: 100%;
font-size: 1.6em;
font-weight: 600;
`
const ButtonGroup = styled.div`
width: 100%;
display: flex;
gap: 1em;
align-items: flex-start;
`
export default EditPatronPermission
